import { components, paths } from 'src/generated/v1';
import { useQueryClient } from '@tanstack/react-query';
import { $api } from './api';

export type ContactItem = components['schemas']['Partner'];

export function transformContactsSortBy(sortBy?: string): string | undefined {
  if (!sortBy) return sortBy;
  if (sortBy.startsWith('address_')) {
    sortBy = sortBy.replace('address_', '');
  }
  if (sortBy === 'zip_code') {
    return 'zip';
  }
  if (sortBy === 'country_name') {
    return 'country_code';
  }
  return sortBy;
}

export const useSingleContactQuery = (id: number) => {
  return $api.useQuery('get', '/partners/{partner_id}', {
    params: { path: { partner_id: id } },
  });
};

export const useContactQuery = (props: paths['/partners']['get']['parameters']['query']) => {
  return $api.useQuery('get', '/partners', {
    params: {
      query: props,
    },
  });
};

export const useContactUpdate = () => {
  const queryClient = useQueryClient();

  return $api.useMutation('put', '/partners/{partner_id}', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/partners'] });
      queryClient.invalidateQueries({ queryKey: ['get', '/partners/{partner_id}'] });
    },
  });
};

export type PartnerInput = components['schemas']['Partner'];
export const useContactCreate = () => {
  const queryClient = useQueryClient();
  return $api.useMutation('post', '/partners', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/partners'] });
    },
  });
};

export const useContactArchive = () => {
  const queryClient = useQueryClient();

  return $api.useMutation('delete', '/partners/{partner_id}', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/partners'] });
      queryClient.invalidateQueries({ queryKey: ['get', '/partners/{partner_id}'] });
    },
  });
};

export const useDeleteContacts = () => {
  const queryClient = useQueryClient();

  return $api.useMutation('put', '/utility/bulk_action/{model}/cancel', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/partners'] });
      queryClient.invalidateQueries({ queryKey: ['get', '/partners/{partner_id}'] });
    },
  });
};
